
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/premier-agent/author/[...slug]",
      function () {
        return require("private-next-pages/premier-agent/author/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/premier-agent/author/[...slug]"])
      });
    }
  